module.exports = __webpack_public_path__ + "assets/loader.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.svg
// module id = 1668
// module chunks = 7